import gql from 'graphql-tag';

const PRODUCTS = gql`
    query(
        $application: [QueryArgument]
        $colour: [QueryArgument]
        $size: [QueryArgument]
        $material: [QueryArgument]
        $look: [QueryArgument]
        $shape: [QueryArgument]
        $texture: [QueryArgument]
        $collection: [QueryArgument]
        $finish: [QueryArgument]
        $price: [QueryArgument]
        $limit: Int
        $offset: Int
        $orderBy: String
        $search: String
    ) {
        count: productCount(
            type: "tile"
            application: $application
            material: $material
            shape: $shape
            texture: $texture
            collection: $collection
            finish: $finish
            defaultPrice: $price
            hasVariant: { colour: $colour, size: $size, look: $look }
            search: $search
        )

        products(
            type: "tile"
            application: $application
            material: $material
            shape: $shape
            texture: $texture
            collection: $collection
            finish: $finish
            defaultPrice: $price
            hasVariant: { colour: $colour, size: $size, look: $look }
            limit: $limit
            offset: $offset
            orderBy: $orderBy
            search: $search
        ) {
            id
            title
            uri
            defaultPrice
            ... on tile_Product {
                vendor {
                    id
                    title
                }
                productTag {
                    id
                    title
                }
                application {
                    id
                    title
                    slug
                }
            }
            defaultVariant {
                id
                title
                price
                salePrice
                isAvailable

                ... on tile_Variant {
                    pricePerM2
                    pricePerPiece
                    colour {
                        id
                        title

                        ... on colours_Category {
                            colourHex
                        }
                    }
                    tileImage @transform(format: "webp") {
                        title
                        url(width: 1, height: 1, immediately: false)
                        srcset(sizes: ["320", "640"])
                    }
                    additionalImages @transform(format: "webp") {
                        title
                        url(width: 1, height: 1, immediately: false)
                        srcset(sizes: ["320", "640"])
                    }
                }
            }
        }
    }
`;

const SAMPLE_PRODUCTS = gql`
    query($limit: Int, $offset: Int, $orderBy: String, $search: String) {
        count: productCount(type: "samples", search: $search)

        products(
            type: "samples"
            limit: $limit
            offset: $offset
            orderBy: $orderBy
            search: $search
        ) {
            id
            title
            uri
            defaultPrice
            ... on samples_Product {
                productTag {
                    id
                    title
                }
                tileImage @transform(format: "webp") {
                    title
                    url(width: 1, height: 1, immediately: false)
                    srcset(sizes: ["320", "640"])
                }
                images @transform(format: "webp") {
                    title
                    url(width: 1, height: 1, immediately: false)
                    srcset(sizes: ["320", "640"])
                }
            }
            defaultVariant {
                id
                title
                price
                salePrice
                isAvailable
            }
        }
    }
`;

export { PRODUCTS, SAMPLE_PRODUCTS };
